export default __webpack_public_path__ + "static/782-a3e8fb43cc55d29060913fa926ccafb1.gif";